import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-[var(--bg)] min-h-screen" }
const _hoisted_2 = { class: "w-full fixed z-40" }
const _hoisted_3 = { class: "flex-1 flex flex-col" }
const _hoisted_4 = { class: "bg-[var(--bg)] group mt-20" }
const _hoisted_5 = { class: "container mx-auto px-12 text-center sm:px-24" }
const _hoisted_6 = { class: "flex flex-col justify-between w-full py-16 mb-8 sm:flex-row sm:items-start" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "flex justify-between items-center border-t border-[var(--border)] pt-8 pb-20" }
const _hoisted_9 = { class: "text-xs text-[var(--text-secondary)] font-light" }
const _hoisted_10 = ["src"]

import { defineAsyncComponent, computed, ref } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const NavBar = defineAsyncComponent(() => import('./components/global/nav-bar.vue'));
const Sidebar = defineAsyncComponent(() => import('@/components/global/sidebar.vue'));
const Notifications = defineAsyncComponent(() => import('@/components/global/notifications.vue'));

const store = useStore();
const showSidebar = computed(() => store.state.sidebar);
const year = ref(new Date().getUTCFullYear());

function clickOutside() {
  if (showSidebar.value) store.commit('toggleSidebar');
}

function toggleSidebar() {
  store.commit('toggleSidebar');
}


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Notifications)),
    (showSidebar.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 bg-black opacity-50 z-30",
          onClick: toggleSidebar,
          onKeydown: toggleSidebar
        }, null, 32))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createVNode(_unref(NavBar)),
      _createVNode(_unref(Sidebar))
    ])), [
      [_directive_click_outside, clickOutside]
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["h-full overflow-y-auto pt-8 relative", {
        'blocker': showSidebar.value,
      }])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_view),
        _createElementVNode("footer", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "w-full h-px bg-line" }, null, -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_router_link, {
                to: _ctx.isAuth ? '/app' : '/',
                class: "mb-10 sm:mb-0"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: _ctx.isLight
                    ? '/img/logo-digi-light.svg'
                    : '/img/logo-digi.svg',
                    alt: "Logo",
                    class: "h-6 opacity-30 group-hover:opacity-100 courser-pointer"
                  }, null, 8, _hoisted_7)
                ]),
                _: 1
              }, 8, ["to"]),
              _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"flex space-x-12 mr-0 opacity-30 group-hover:opacity-100 transition-all duration-500 ease-in-out sm:mr-20 sm:mx-0 sm:space-x-20\" data-v-547862b2><div class=\"text-left\" data-v-547862b2><h3 class=\"text-sm text-[var(--text)] font-regular mb-4\" data-v-547862b2>Products</h3><ul class=\"space-y-2 text-xs text-[var(--text)] font-light pl-1\" data-v-547862b2><li data-v-547862b2><a href=\"#\" class=\"opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out\" data-v-547862b2>Sky </a></li><li data-v-547862b2><a href=\"https://fireweb.digiapps.com.co/\" class=\"opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out\" data-v-547862b2>Fireweb </a></li><li data-v-547862b2><a href=\"#\" class=\"opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out\" data-v-547862b2>DigiCare </a></li></ul></div><div class=\"text-left\" data-v-547862b2><h3 class=\"text-sm text-[var(--text)] font-regular mb-4\" data-v-547862b2>Contact Us</h3><ul class=\"space-y-2 text-xs text-[var(--text)] font-light pl-1\" data-v-547862b2><li data-v-547862b2><a href=\"https://mail.google.com/mail/?view=cm&amp;fs=1&amp;to=support@digiapps.com.co\" target=\"_blank\" class=\"opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out\" data-v-547862b2>Help Center </a></li><li data-v-547862b2><a href=\"https://discord.gg/UsGXbTkJSE\" target=\"_blank\" class=\"opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out\" data-v-547862b2>Discord </a></li></ul></div><div class=\"text-left\" data-v-547862b2><h3 class=\"text-sm text-[var(--text)] font-regular mb-4\" data-v-547862b2>Legal</h3><ul class=\"space-y-2 text-xs text-[var(--text)] font-light pl-1\" data-v-547862b2><li data-v-547862b2><a href=\"/privacy-policy\" class=\"opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out\" data-v-547862b2>Privacy Policy </a></li></ul></div></div>", 1))
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", _hoisted_9, "© " + _toDisplayString(_ctx.currentYear) + " digi systems All rights reserved.", 1),
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleTheme && _ctx.toggleTheme(...args))),
                class: "rounded-full"
              }, [
                _createElementVNode("img", {
                  src: _ctx.isLight
                    ? '/icon/icon-light.svg'
                    : '/icon/icon-dark.svg',
                  alt: "theme toggle",
                  class: "w-5 h-5 opacity-70 hover:opacity-100 transition"
                }, null, 8, _hoisted_10)
              ])
            ])
          ])
        ])
      ])
    ], 2)
  ]))
}
}

})